// extracted by mini-css-extract-plugin
export default {"containerWrapper":"Loader_containerWrapper__nvlRO","rotation":"Loader_rotation__CRssU","wrapper":"Loader_wrapper__BNeoi"};